import React, { useState, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Drawer, ListItem } from '@material-ui/core'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import './ProductCard.css'
import CommonContext from '@/product/context/common/commonContext'
import { useFormik } from 'formik'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { dateTimeFormatFunctionNew } from '@/custom/common/components'
import Timer from '@/custom/common/timer'
import { FALLBACK_IMAGE } from '@/utils'
import SignContext from '@/custom/context/signContext'
// import Timer from '@/product/common/timer'
import { handleRedirectInternal } from '@/product/common/components'
import { Calendar } from '@material-ui/pickers'
import { CalendarToday } from '@material-ui/icons'
const useStyles = makeStyles({
    fullList: {
        width: 'auto',
    },
})
import AuthContext from '@/product/context/auth/authContext'
function AuctionCard(props) {
    const commonContext = useContext(CommonContext)
    const { setSearchValue, allLocations } = commonContext
    const [auction, setAuction] = useState({})
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated } = authContext
    const history = useHistory()
    const classes = useStyles()
    const { loginPopup, handleLoginPopup, handleKycPopup, kycPopup } = useContext(SignContext)
    const [state, setState] = useState({
        bottom: false,
    })

    useEffect(() => {
        setAuction(props.data)
    }, [props.data])

    const formik = useFormik({
        initialValues: {
            auctionid: '',
        },
    })

    const auctionRedirect = (id) => {
        history.push({
            pathname: '/liveAuction/' + id,
            state: auction,
        })
        window.scrollTo(0, 0)
    }

    // const handleRedirectInternal = (path) => {
    //     history.push(`/${path}`)
    //     window.scrollTo(0, 0)
    // }

    const handleClose = (state) => {
        state(false)
    }

    const handleOpen = (state) => {
        state(true)
    }

    const toggleDrawer = (anchor, open, data) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }
        if (open) {
            setState({ ...state, [anchor]: open, data: data })
        } else {
            setState({ ...state, [anchor]: open, data: {} })
        }
    }

    return (
        <div className="productCardGrid">
            <div className="gridBadge d-flex align-items-center" style={{ gap: '3px' }}>
                {/* <img src=""/> */}
                <span className="material-icons" style={{ fontSize: '14px', lineHeight: '1.4' }}>
                    language
                </span>
                <span>
                    {' '}
                    {auction.sale_type == 'PT'
                        ? 'Private'
                        : auction.sale_type == 'R'
                        ? 'Reverse'
                        : 'Online'}
                </span>
            </div>
            <div className="pcgImg">
                <img
                    src={`${global.site_url}/uploads/auction/${auction.avatar}`}
                    onError={(e) => FALLBACK_IMAGE(e)}
                    alt="Live Auction"
                />
                <div className="gridLotAuction">
                    {`(${auction.all_projects_count} Lots | Auction Id:${auction.id})`}
                </div>
            </div>
            <div className="gridContent">
                <h2 className="gridProdTitle">{auction.title}</h2>
                <h2 className="gridProdTitle d-flex justify-content-start align-items-center mb-0">
                    <p
                        className="mb-0"
                        dangerouslySetInnerHTML={{
                            __html: auction.description,
                        }}
                    ></p>
                </h2>
                <p className="gridBidInfo customGirdInfo d-flex align-items-center mb-2">
                    <span
                        className="material-icons"
                        style={{ fontSize: '20px', lineHeight: '1.4' }}
                    >
                        calendar_month
                    </span>
                    <span>{dateTimeFormatFunctionNew(auction.date_added)}</span>-
                    <span>{dateTimeFormatFunctionNew(auction.date_closed)}</span>
                </p>
                {/* <p className="gridBidInfo d-flex justify-content-between align-items-center mb-4">
                    <span>{'End date'}:</span>
                   
                </p>{' '} */}
                {auction.market_status == 'closed' ? (
                    <PrimaryButton
                        id="view_auctionCard"
                        onClick={() => auctionRedirect(auction.id)}
                        label="Auction Closed"
                        btnSize="small"
                        className="gridViewBtn w-100"
                    />
                ) : (
                    <div className="d-flex w-100 gridViewCardButton" style={{ gap: '10px' }}>
                        <PrimaryButton
                            id="view_auctionCard"
                            onClick={() => {
                                console.log(!isAuthenticated)
                                if (!isAuthenticated) {
                                    handleLoginPopup()
                                } else if (user && !user.is_kyc_done) {
                                    handleKycPopup()
                                } else {
                                    auctionRedirect(auction.id)
                                }
                            }}
                            label="Bid Now"
                            className="gridViewBtn w-100"
                            btnSize="small"
                        />
                        <PrimaryButton
                            id="view_auctionCard"
                            onClick={() => auctionRedirect(auction.id)}
                            label="View Lot"
                            btnSize="small"
                            className="gridViewBtn w-100"
                        />{' '}
                    </div>
                )}
            </div>
        </div>
    )
}

export default AuctionCard
